<template>
    <Form
        submitButtonName="Update Signal"
        :onSubmit="onSubmit"
        :recordProps="record"
    />
</template>

<script>
import Form from "./Form.vue";
import SignalService from "@/services/signal.service.js";
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

const toastId = ref('');

export default {
    name: "BroadcastSignalEdit",
    components: {
        Form
    },
    data() {
        return {
            record: {},
        };
    },
    mounted(){
        this.getRecord()
    },
    methods: {
        showLoading(){
            toastId.value = toast.loading('Please wait...');
        },
        hideLoading(){
            setTimeout(() => {
                toast.remove(toastId.value)
            }, 1000); 
        },
        showSuccess(){
            toast.update(toastId.value, {
                render: "Update Successfully",
                closeOnClick: true,
                closeButton: true,
                type: 'success',
                isLoading: false,
                autoClose: 3000
            });
            
            setTimeout(() => {
                this.$router.replace('/broadcast-signal')
            }, 1000);     
        },
        showFailed(e){
            toast.update(toastId.value, {
                render: e,
                closeOnClick: true,
                closeButton: true,
                type: 'error',
                isLoading: false,
                autoClose: 3000
            });
        },
        onSubmit(data){
            this.showLoading()
            
            SignalService.update(data, this.$route.params.id).then(() => {
                this.showSuccess()
            }).catch(e => {
                this.showFailed(e.response.data.code_message)           
            });
        },
        getRecord(){
            this.showLoading()

            SignalService.get(this.$route.params.id).then(e => {
                this.record = e.data.signal_data
                this.hideLoading()
            }).catch(e => {
                this.showFailed(e.response.data.code_message)           
            });
        }
    }
};
</script>